
<div *ngIf="loader; else elseBlock" class="spinner">

  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<ng-template #elseBlock style="display: flex; justify-content: center;">

    <mat-form-field appearance="fill" class="buttonFilter">
      <mat-label>File</mat-label>
      <mat-select [(value)]="selectedFile" (selectionChange)="applyFilterSelect()">
        <mat-option value={{null}}>No seleccionar</mat-option>
        <mat-option *ngFor="let file of fileArray" value={{file}}>{{file}}</mat-option>

      </mat-select>
    </mat-form-field>

  <mat-form-field appearance="fill" class="buttonFilter">
    <mat-label>Categoría Producto</mat-label>
    <mat-select [(value)]="selectedCategoriaProducto" (selectionChange)="applyFilterSelect()">
      <mat-option value={{null}}>No seleccionar</mat-option>
      <mat-option *ngFor="let categoriaProducto of arrayCategoriaProducto" value={{categoriaProducto}}>{{categoriaProducto}}</mat-option>

    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill" class="buttonFilter">
    <mat-label>Sub Categoría Producto</mat-label>
    <mat-select [(value)]="selectedSubCategoriaProducto" (selectionChange)="applyFilterSelect()">
      <mat-option value={{null}}>No seleccionar</mat-option>
      <mat-option *ngFor="let subCategoriaProducto of arraySubCategoriaProducto" value={{subCategoriaProducto}}>{{subCategoriaProducto}}</mat-option>

    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill" class="buttonFilter">
    <mat-label>Tipo Servicio</mat-label>
    <mat-select [(value)]="selectedTipoServicio" (selectionChange)="applyFilterSelect()">
      <mat-option value={{null}}>No seleccionar</mat-option>
      <mat-option *ngFor="let tipo of arrayTipoServicio" value={{tipo}}>{{tipo}}</mat-option>

    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill" class="buttonFilter">
    <mat-label>Categoría Servicio</mat-label>
    <mat-select [(value)]="selectedSubCategoria" (selectionChange)="applyFilterSelect()">
      <mat-option value={{null}}>No seleccionar</mat-option>
      <mat-option *ngFor="let subcategoria of arraySubCategoria" value={{subcategoria}}>{{subcategoria}}</mat-option>

    </mat-select>
  </mat-form-field>


<!--  <mat-form-field appearance="fill" class="buttonFilter">-->
<!--    <mat-label>File</mat-label>-->
<!--    <mat-select [(value)]="selectedFile" (selectionChange)="applyFilterSelect()">-->
<!--      <mat-option value={{null}}>No seleccionar</mat-option>-->
<!--      <mat-option *ngFor="let subcategoria of arraySubCategoria" value={{subcategoria}}>{{subcategoria}}</mat-option>-->

<!--    </mat-select>-->
<!--  </mat-form-field>-->


    <div style="display: flex; justify-content: center;margin: 1rem">
      <mat-form-field appearance="outline" class="divInputSearch">
        <mat-label>Filtrar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar Búsqueda" />
      </mat-form-field>
    </div>

    <div class="secctionButtonOS">
      <div style="height: 50%; ">
        <button mat-raised-button [ngClass]="{'buttonActive': estadoBtnMasivo>0, 'buttonDisable': estadoBtnMasivo===0}"
          (click)="sendReservaOS()">Generar OS</button>
      </div>
      <div  style="height: 50%; height: 40px !important;">
        <p *ngIf="estadoBtnMasivo===0 && messageButtonOS" style="color: red; font-size: 0.8rem;"><i>* Seleccione los servicos que desea
            reservar Orden de Servico</i></p>
      </div>

    </div>
</ng-template>

<!--  &lt;!&ndash; *ngIf="estadoBtnMasivo>0" &ndash;&gt;-->

<div  class="example-container">

  <table *ngIf="!loader" mat-table [dataSource]="dataSource" class="mat-elevation-z8">


      <ng-container matColumnDef="Check">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? toggleAllRows(dataSource.data) : null"
                        [checked]="isAllSelected(dataSource.data)">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox [checked]="element.checked" (change)="updateCheck(element)">
          </mat-checkbox>
        </td>
      </ng-container>

    <ng-container matColumnDef="fileNumber">
      <th mat-header-cell *matHeaderCellDef  class="secctionHeaderBody"> FILE </th>
      <td mat-cell *matCellDef="let row" class="secctionHeaderBody"> {{row.fileNumber}} </td>
    </ng-container>

    <ng-container matColumnDef="categoriaProducto">
      <th mat-header-cell *matHeaderCellDef  class="secctionHeaderBody"> CATEGORIA </th>
      <td mat-cell *matCellDef="let row"  class="secctionHeaderBody"> {{row.objProducto?.categoriaProducto }} </td>

    </ng-container> <ng-container matColumnDef="subCategoriaProducto">
    <th mat-header-cell *matHeaderCellDef  class="secctionHeaderBody"> SUB-CATEGORIA </th>
    <td mat-cell *matCellDef="let row"  class="secctionHeaderBody"> {{row.objProducto?.subCategoriaProducto }} </td>
  </ng-container>

    <ng-container matColumnDef="ruta">
      <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody"> RUTA </th>
      <td mat-cell *matCellDef="let row" class="secctionHeaderBody"> {{row.objProducto?.nombre }} </td>
    </ng-container>

<!--    <ng-container matColumnDef="createdAt">-->
<!--      <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody"> CREACIÓN</th>-->
<!--      <td mat-cell *matCellDef="let row" class="secctionHeaderBody"> {{row.createdAt | date:'dd/MM/yyyy'}} </td>-->
<!--    </ng-container>-->

<!--    <ng-container matColumnDef="updatedAt">-->
<!--      <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody"> ACTUALIZACIÓN </th>-->
<!--      <td mat-cell *matCellDef="let row" class="secctionHeaderBody"> {{row.updatedAt | date:'dd/MM/yyyy'}} </td>-->
<!--    </ng-container>-->

      <ng-container matColumnDef="categoriaServicio">
        <th mat-header-cell *matHeaderCellDef >Tipo de  Servicio </th>
        <td mat-cell *matCellDef="let element" > {{element.tipoServicio}}</td>
      </ng-container>

      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody"> Nombre Service</th>
        <td mat-cell *matCellDef="let element" class="secctionBody"> {{element.nombreServicio}} </td>
      </ng-container>

      <ng-container matColumnDef="proveedor">
        <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody"> Proveedor</th>
        <td mat-cell *matCellDef="let element" class="secctionBody"> {{element.objProvider.nombre}} </td>
      </ng-container>

      <ng-container matColumnDef="orderNumber">
        <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody"> Num OS</th>
        <td mat-cell *matCellDef="let element" class="secctionBody"> {{ element.order?.displayCode || element.order?.orderNumber }} </td>
      </ng-container>


      <ng-container matColumnDef="reservationStatus">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="secctionHeaderBody"> Estado reserva </mat-header-cell>
        <mat-cell *matCellDef="let element" class="secctionBody">
          {{ element.order?.reservationStatus || '-' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="cambiarProvider">
        <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody"> Editar Proveedor</th>
        <td mat-cell *matCellDef="let element" class="secctionBody">
          <!-- <mat-icon
            (click)="openDialogProvider(element.tipoServicio ,element.nombreServicio, element.itineraryId, element.id, element.objProvider.nombre)"
           class="icon_color_black"
            >loop</mat-icon>  -->
          <mat-icon  class="icon_color_black"
                     (click)="openDialogProvider(element.tipoServicio ,element.nombreServicio, element.itineraryId, element.id,element.objProvider.nombre , element.objProvider.categoriaServicio, element.locacion  )"
          >person</mat-icon></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsServicios"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsServicios"></tr>
    </table>

</div>
  <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
  </mat-paginator>

<!--    &lt;!&ndash; <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">-->
<!--      <th mat-header-cell *matHeaderCellDef> {{column.toUpperCase()}} </th>-->
<!--      <td mat-cell *matCellDef="let element"> {{element[column]}} </td>-->
<!--    </ng-container> &ndash;&gt;-->


<!--&lt;!&ndash;    <ng-container matColumnDef="fileNumber">&ndash;&gt;-->
<!--&lt;!&ndash;      <th mat-header-cell *matHeaderCellDef  class="secctionHeaderBody"> FILE </th>&ndash;&gt;-->
<!--&lt;!&ndash;      <td mat-cell *matCellDef="let row" class="secctionHeaderBody"> {{row.fileNumber&ndash;&gt;-->
<!--&lt;!&ndash;      }} </td>&ndash;&gt;-->
<!--&lt;!&ndash;    </ng-container>&ndash;&gt;-->

<!--&lt;!&ndash;    <ng-container matColumnDef="categoriaProducto">&ndash;&gt;-->
<!--&lt;!&ndash;      <th mat-header-cell *matHeaderCellDef  class="secctionHeaderBody"> CATEGORIA </th>&ndash;&gt;-->
<!--&lt;!&ndash;      <td mat-cell *matCellDef="let row"  class="secctionHeaderBody"> {{row.categoriaProducto }} </td>&ndash;&gt;-->

<!--&lt;!&ndash;    </ng-container> <ng-container matColumnDef="subCategoriaProducto">&ndash;&gt;-->
<!--&lt;!&ndash;      <th mat-header-cell *matHeaderCellDef  class="secctionHeaderBody"> SUB-CATEGORIA </th>&ndash;&gt;-->
<!--&lt;!&ndash;      <td mat-cell *matCellDef="let row"  class="secctionHeaderBody"> {{row.subCategoriaProducto }} </td>&ndash;&gt;-->
<!--&lt;!&ndash;    </ng-container>&ndash;&gt;-->

<!--&lt;!&ndash;    <ng-container matColumnDef="ruta">&ndash;&gt;-->
<!--&lt;!&ndash;      <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody"> RUTA </th>&ndash;&gt;-->
<!--&lt;!&ndash;      <td mat-cell *matCellDef="let row" class="secctionHeaderBody"> {{row.ruta }} </td>&ndash;&gt;-->
<!--&lt;!&ndash;    </ng-container>&ndash;&gt;-->

<!--&lt;!&ndash;    <ng-container matColumnDef="createdAt">&ndash;&gt;-->
<!--&lt;!&ndash;      <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody"> CREACIÓN</th>&ndash;&gt;-->
<!--&lt;!&ndash;      <td mat-cell *matCellDef="let row" class="secctionHeaderBody"> {{row.createdAt | date:'dd/MM/yyyy'}} </td>&ndash;&gt;-->
<!--&lt;!&ndash;    </ng-container>&ndash;&gt;-->

<!--&lt;!&ndash;    <ng-container matColumnDef="updatedAt">&ndash;&gt;-->
<!--&lt;!&ndash;      <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody"> ACTUALIZACIÓN </th>&ndash;&gt;-->
<!--&lt;!&ndash;      <td mat-cell *matCellDef="let row" class="secctionHeaderBody"> {{row.updatedAt | date:'dd/MM/yyyy'}} </td>&ndash;&gt;-->
<!--&lt;!&ndash;    </ng-container>&ndash;&gt;-->



<!--    &lt;!&ndash; <ng-container matColumnDef="createdAt">-->
<!--      <th mat-header-cell > CREACIÓN </mat-header-cell>-->
<!--      <td> *matCellDef="let row"> {{row.createdAt | date:'dd/MM/yyyy'}} </mat-cell>-->
<!--    </ng-container> &ndash;&gt;-->
<!--    &lt;!&ndash; <ng-container matColumnDef="updatedAt">-->
<!--      <th mat-header-cell > ACTUALIZACIÓN </mat-header-cell>-->
<!--      <td> *matCellDef="let row"> {{row.updatedAt | date:'dd/MM/yyyy'}} </mat-cell>-->
<!--    </ng-container>-->
<!-- &ndash;&gt;-->
<!--    &lt;!&ndash; <ng-container matColumnDef="edit">-->
<!--      <th mat-header-cell *matHeaderCellDef>-</th>-->
<!--      <td mat-cell *matCellDef="let element; let i =dataIndex" (click)="$event.stopPropagation()">-->
<!--        <button (click)="openDialogEdit(element.fileId,element.fileProductId, element.idItinerary)" mat-icon-button-->
<!--          color="primary">-->
<!--          <mat-icon class="icon-color">edit</mat-icon>-->
<!--        </button>-->
<!--      </td>-->
<!--    </ng-container> &ndash;&gt;-->

<!--&lt;!&ndash;    <ng-container matColumnDef="expand">&ndash;&gt;-->
<!--&lt;!&ndash;      <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>&ndash;&gt;-->
<!--&lt;!&ndash;      <td mat-cell *matCellDef="let element">&ndash;&gt;-->
<!--&lt;!&ndash;        <button mat-icon-button aria-label="expand row"&ndash;&gt;-->
<!--&lt;!&ndash;          (click)="(modelExpand = modelExpand === element ? null : element); $event.stopPropagation()">&ndash;&gt;-->
<!--&lt;!&ndash;          <mat-icon *ngIf="modelExpand !== element">keyboard_arrow_down</mat-icon>&ndash;&gt;-->
<!--&lt;!&ndash;          <mat-icon *ngIf="modelExpand === element">keyboard_arrow_up</mat-icon>&ndash;&gt;-->
<!--&lt;!&ndash;        </button>&ndash;&gt;-->
<!--&lt;!&ndash;      </td>&ndash;&gt;-->
<!--&lt;!&ndash;    </ng-container>&ndash;&gt;-->


<!--&lt;!&ndash;    <ng-container matColumnDef="expandedDetail">&ndash;&gt;-->
<!--&lt;!&ndash;      <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="example-element-detail" [@detailExpand]="element == modelExpand ? 'expanded' : 'collapsed'">&ndash;&gt;-->

<!--&lt;!&ndash;          <div class="example-element-description">&ndash;&gt;-->


<!--&lt;!&ndash;            <table mat-table [dataSource]="element.services" class="mat-elevation-z8">&ndash;&gt;-->

<!--&lt;!&ndash;              <ng-container matColumnDef="Check">&ndash;&gt;-->
<!--&lt;!&ndash;                <th mat-header-cell *matHeaderCellDef>&ndash;&gt;-->
<!--&lt;!&ndash;                  <mat-checkbox (change)="$event ? toggleAllRows(element.services) : null"&ndash;&gt;-->
<!--&lt;!&ndash;                    [checked]="isAllSelected(element.services)">&ndash;&gt;-->
<!--&lt;!&ndash;                  </mat-checkbox>&ndash;&gt;-->
<!--&lt;!&ndash;                </th>&ndash;&gt;-->
<!--&lt;!&ndash;                <td mat-cell *matCellDef="let element">&ndash;&gt;-->
<!--&lt;!&ndash;                  <mat-checkbox [checked]="element.checked" (change)="updateCheck(element)">&ndash;&gt;-->
<!--&lt;!&ndash;                  </mat-checkbox>&ndash;&gt;-->
<!--&lt;!&ndash;                </td>&ndash;&gt;-->
<!--&lt;!&ndash;              </ng-container>&ndash;&gt;-->


<!--&lt;!&ndash;              <ng-container matColumnDef="categoriaServicio">&ndash;&gt;-->
<!--&lt;!&ndash;                <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody">Cateria de  Servicio </th>&ndash;&gt;-->
<!--&lt;!&ndash;                <td mat-cell *matCellDef="let element" class="secctionBody"> {{element.tipoServicio}}</td>&ndash;&gt;-->
<!--&lt;!&ndash;              </ng-container>&ndash;&gt;-->

<!--&lt;!&ndash;              <ng-container matColumnDef="nombre">&ndash;&gt;-->
<!--&lt;!&ndash;                <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody"> Nombre Service</th>&ndash;&gt;-->
<!--&lt;!&ndash;                <td mat-cell *matCellDef="let element" class="secctionBody"> {{element.nombreServicio}} </td>&ndash;&gt;-->
<!--&lt;!&ndash;              </ng-container>&ndash;&gt;-->

<!--&lt;!&ndash;              <ng-container matColumnDef="proveedor">&ndash;&gt;-->
<!--&lt;!&ndash;                <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody"> Proveedor</th>&ndash;&gt;-->
<!--&lt;!&ndash;                <td mat-cell *matCellDef="let element" class="secctionBody"> {{element.objProvider.nombre}} </td>&ndash;&gt;-->
<!--&lt;!&ndash;              </ng-container>&ndash;&gt;-->

<!--&lt;!&ndash;              <ng-container matColumnDef="numOS">&ndash;&gt;-->
<!--&lt;!&ndash;                <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody"> Num OS</th>&ndash;&gt;-->
<!--&lt;!&ndash;                <td mat-cell *matCellDef="let element" class="secctionBody"> {{element.numOS}} </td>&ndash;&gt;-->
<!--&lt;!&ndash;              </ng-container>&ndash;&gt;-->

<!--&lt;!&ndash;              <ng-container matColumnDef="estadoReserva">&ndash;&gt;-->
<!--&lt;!&ndash;                <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody"> Estado Reserva</th>&ndash;&gt;-->
<!--&lt;!&ndash;                <td mat-cell *matCellDef="let element" class="secctionBody"> {{element.estadoReserva}} </td>&ndash;&gt;-->
<!--&lt;!&ndash;              </ng-container>&ndash;&gt;-->


<!--&lt;!&ndash;              <ng-container matColumnDef="cambiarProvider">&ndash;&gt;-->
<!--&lt;!&ndash;                <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody"> Editar Proveedor</th>&ndash;&gt;-->
<!--&lt;!&ndash;                <td mat-cell *matCellDef="let element" class="secctionBody">&ndash;&gt;-->
<!--&lt;!&ndash;                  &lt;!&ndash; <mat-icon&ndash;&gt;-->
<!--&lt;!&ndash;                    (click)="openDialogProvider(element.tipoServicio ,element.nombreServicio, element.itineraryId, element.id, element.objProvider.nombre)"&ndash;&gt;-->
<!--&lt;!&ndash;                   class="icon_color_black"&ndash;&gt;-->
<!--&lt;!&ndash;                    >loop</mat-icon>  &ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                    <mat-icon  class="icon_color_black"&ndash;&gt;-->
<!--&lt;!&ndash;                    (click)="openDialogProvider(element.tipoServicio ,element.nombreServicio, element.itineraryId, element.id,element.objProvider.nombre )"&ndash;&gt;-->
<!--&lt;!&ndash;                    >person</mat-icon></td>&ndash;&gt;-->
<!--&lt;!&ndash;              </ng-container>&ndash;&gt;-->



<!--              <ng-container matColumnDef="cambiarOS">-->
<!--&lt;!&ndash;                <th mat-header-cell *matHeaderCellDef class="secctionHeaderBody"> Enviar OS</th>&ndash;&gt;-->
<!--&lt;!&ndash;                <td mat-cell *matCellDef="let element" class="secctionBody"> <mat-icon class="secctionHeaderBody" (click)="sendOneReservaOS(element)"&ndash;&gt;-->
<!--&lt;!&ndash;                  class="icon_color_black"&ndash;&gt;-->
<!--&lt;!&ndash;                    >mail_outline</mat-icon> </td>&ndash;&gt;-->
<!--&lt;!&ndash;              </ng-container>&ndash;&gt;-->



<!--&lt;!&ndash;              <tr mat-header-row *matHeaderRowDef="displayedColumnsServicios"></tr>&ndash;&gt;-->
<!--&lt;!&ndash;              <tr mat-row *matRowDef="let row; columns: displayedColumnsServicios"></tr>&ndash;&gt;-->
<!--&lt;!&ndash;            </table>&ndash;&gt;-->
<!--&lt;!&ndash;            <br>&ndash;&gt;-->

<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;      </td>&ndash;&gt;-->
<!--&lt;!&ndash;    </ng-container>&ndash;&gt;-->

<!--&lt;!&ndash;    <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>&ndash;&gt;-->
<!--&lt;!&ndash;    <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;" class="example-element-row"&ndash;&gt;-->
<!--&lt;!&ndash;      [class.example-expanded-row]="modelExpand === element"&ndash;&gt;-->
<!--&lt;!&ndash;      (click)="modelExpand = modelExpand === element ? null : element">&ndash;&gt;-->
<!--&lt;!&ndash;    </tr>&ndash;&gt;-->
<!--&lt;!&ndash;    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>&ndash;&gt;-->


<!--&lt;!&ndash;  <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>&ndash;&gt;-->
<!--&lt;!&ndash;  </mat-paginator>&ndash;&gt;-->

<!--&lt;!&ndash;  <mat-header-row *matHeaderRowDef="displayedColumns2"></mat-header-row>&ndash;&gt;-->
<!--&lt;!&ndash;  <mat-row *matRowDef="let row; columns: displayedColumns2;">&ndash;&gt;-->
<!--&lt;!&ndash;  </mat-row>&ndash;&gt;-->

<!--  &lt;!&ndash; <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator> &ndash;&gt;-->


<!--  &lt;!&ndash; </div> &ndash;&gt;-->

<!--</ng-template>-->




